import React from 'react';
import { useAppSelector } from '../../logic/store/Store';
import { SingleRow } from './SingleRow';
import { sortByHighestSeverity } from '../../logic/store/Insights/InsightsModels';
import { SectionHeader } from './Components/SectionHeader';

interface IMultiTerritoryViewProps
{
	onSelectTerritory: (Id: string) => void;
}

/**
 * List of the territories the current user is responsible for.
 * Only shown when the user sits on more than one hierarchy node -- with a single territory
 * the parent navigates straight into it.
 */
export const MultiTerritoryView = (props: IMultiTerritoryViewProps) =>
{
	const { onSelectTerritory } = props;

	// AI Insights objects from slice
	const territoryInsights = useAppSelector(s => s.insights.territoryAnalyses);

	// Sort the territories by severity
	const sortedTerritories = React.useMemo(() =>
	{
		if (!territoryInsights || territoryInsights.length === 0)
		{
			return [];
		}

		return sortByHighestSeverity(territoryInsights, t => t.Report?.Concerns || [], t => t.TerritoryName ?? t.TerritoryExternalId);
	}, [territoryInsights]);

	return (
		<div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '98%', overflow: 'hidden' }}>
			<SectionHeader>
					Territories
			</SectionHeader>
			<div style={{ display: 'flex', overflowY: 'auto', flexDirection: 'column', alignItems: 'center', paddingBottom: 20 }}>
				{
					sortedTerritories?.map((territory) =>
					{
						return (
							<SingleRow
								key={territory.item.TerritoryExternalId}
								Id={territory.item.TerritoryExternalId}
								onSelect={onSelectTerritory}
								Name={territory.item.TerritoryName ?? territory.item.TerritoryExternalId}
								NumberOfItems={territory.item.SalesRepCount}
								NumberOfItemsTitle={'Sales Reps'}
								// Nothing to drill into when no sales rep beneath the node has been analysed
								DisabledMessage={territory.item.SalesRepCount > 0 ? undefined : 'No sales rep associated'}
								Severity={territory.highestSeverity}
								SeverityCount={territory.count}
							/>
						);
					})
				}
			</div>
		</div>
	);
};
